import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { Cross } from "../shared/Icon";
import { SectionText } from "../shared/Section";
import { ExternalLink } from "../shared/Icon";

const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  max-width: 600px;
  width: 100%;
  height: auto;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  pointer-events: ${(props) => (props.isOpen ? "auto" : "none")};
  transition: 400ms;
  padding: 0;
`;

const Heading = styled.div`
  font-size: 2.8rem;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 1.2rem;
  & strong {
    font-weight: inherit;
    color: ${(props) => props.theme.accentColor};
  }
  @media (${(props) => props.theme.breakpoint}) {
    font-size: 1.7rem;
    margin-bottom: 0;
  }
`;

const Header = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 0.5rem;
  @media (${(props) => props.theme.breakpoint}) {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  img {
    width: auto;
    height: 400px;
  }
  @media (${(props) => props.theme.breakpoint}) {
    width: calc(100% - 5vw);
    height: auto;
    img {
      height: auto;
      width: 100%;
    }
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.2rem;
  @media (${(props) => props.theme.breakpoint}) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const CloseIcon = styled.button`
  position: absolute;
  top: 0px;
  left: -34px;
  display: flex;
  align-items: center;
  height: 2.8rem;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  color: #ffffff;
  @media (${(props) => props.theme.breakpoint}) {
    position: relative;
    font-size: 1.7rem;
  }
`;

const Text = styled(SectionText)`
  flex: 1;
  margin-right: 1.5rem;
`;

const Link = styled.a`
  color: #fff;
  text-decoration: none;
  font-size: 0.8rem;
  line-height: 1.8;
  opacity: 0.7;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
  @media (${(props) => props.theme.breakpoint}) {
    margin-top: 1rem;
  }
  svg {
    width: 0.8rem;
    height: 0.8rem;
    margin-left: 0.3rem;
  }
  span {
    display: flex;
    align-items: center;
  }
`;

const Card = ({ project, isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Container isOpen={isOpen}>
      <Header>
        <CloseIcon onClick={onClose}>
          <Cross />
        </CloseIcon>
        <Heading>{project.title}</Heading>
      </Header>
      <ImageWrapper>
        <img src={process.env.PUBLIC_URL + project.image} alt="" />
      </ImageWrapper>
      <Row>
        <Text>{project.description}</Text>
        {project.link && (
          <Link href={project.link} target="_blank" rel="noreferrer">
            <span>
              {t("Card.visit")} <ExternalLink />
            </span>
          </Link>
        )}
      </Row>
    </Container>
  );
};

export default Card;
